import { createQuestionFromConfiguration } from '../../../logbook/views/QuestionView';
import {
    Card,
    Exercise,
    LabelBody,
    LabelDisplay1,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
    Textarea,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { IllustrationCrossroads } from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import { normalizeInput, useSyncedState } from '../../useSyncedState';

const startActionTextKey = 'module2Exercise8StartActionText';
const stopActionTextKey = 'module2Exercise8StopActionText';
const continueActionTextKey = 'module2Exercise8ContinueActionText';

export const exerciseData28: ExerciseData = {
    ExerciseView: Module2Exercise8,
    dataKeys: [startActionTextKey, stopActionTextKey, continueActionTextKey],
    questions: [
        createQuestionFromConfiguration({
            title: 'Hvad vil du starte med at gøre?',
            description:
                'F.eks. Jeg vil bruge en vejrtrækningsøvelse, når jeg føler mig presset.',
            dataKeys: [startActionTextKey],
        }),
        createQuestionFromConfiguration({
            title: 'Hvad vil du stoppe med at gøre?',
            description:
                'F.eks. Jeg vil stoppe med at bebrejde mig selv, når jeg bliver ked af det.',
            dataKeys: [stopActionTextKey],
        }),
        createQuestionFromConfiguration({
            title: 'Hvad vil du fortsætte med at gøre?',
            description:
                'F.eks. jeg vil fortsætte med at give mig selv små pauser i løbet af dagen.',
            dataKeys: [continueActionTextKey],
        }),
    ],
};

function Module2Exercise8({ exercise, onContinue }: ExerciseViewProps) {
    const [startActionText, setStartActionText] = useSyncedState<string>(
        exercise.Data[startActionTextKey] ?? '',
    );
    const [stopActionText, setStopActionText] = useSyncedState<string>(
        exercise.Data[stopActionTextKey] ?? '',
    );
    const [continueActionText, setContinueActionText] = useSyncedState<string>(
        exercise.Data[continueActionTextKey] ?? '',
    );

    return (
        <Exercise title="Start, stop og fortsæt">
            <LabelDisplay2 class="mb-10 mt-20">
                Små ændringer i hverdagen
            </LabelDisplay2>
            <LabelBody>
                Du er i dette modul blevet introduceret til en række øvelser og
                redskaber. Du inviteres nu til at formulere én ting, du vil
                starte med at gøre hver dag, én ting du vil forsøge at stoppe
                med og én ting du vil fortsætte med.
            </LabelBody>
            <IllustrationCrossroads className="mx-auto my-30" />
            <Card class="mb-30">
                <LabelDisplay1 class="mb-20 mt-10">
                    Hvad vil du starte med at gøre?
                </LabelDisplay1>
                <Textarea
                    className="mb-30 mt-20"
                    text={startActionText}
                    onChangeText={setStartActionText}
                    placeholder="F.eks. Jeg vil bruge en vejrtrækningsøvelse, når jeg føler mig presset."
                />
                <LabelDisplay1 class="mb-20 mt-30">
                    Hvad vil du stoppe med at gøre?
                </LabelDisplay1>
                <Textarea
                    className="mb-30 mt-20"
                    text={stopActionText}
                    onChangeText={setStopActionText}
                    placeholder="F.eks. Jeg vil stoppe med at bebrejde mig selv, når jeg bliver ked af det."
                />
                <LabelDisplay1 class="mb-20 mt-30">
                    Hvad vil du fortsætte med at gøre?
                </LabelDisplay1>
                <Textarea
                    className="mb-10 mt-20"
                    text={continueActionText}
                    onChangeText={setContinueActionText}
                    placeholder="F.eks. jeg vil fortsætte med at give mig selv små pauser i løbet af dagen."
                />
                <LabelBody>
                    Dit svar bliver gemt i logbogen, når du fortsætter.
                </LabelBody>
            </Card>
            <Spacer />
            <SecondaryButton
                onClick={() => {
                    onContinue({
                        status: ExerciseStatus.Completed,
                        goToNext: false,
                        data: {
                            [startActionTextKey]:
                                normalizeInput(startActionText),
                            [stopActionTextKey]: normalizeInput(stopActionText),
                            [continueActionTextKey]:
                                normalizeInput(continueActionText),
                        },
                    });
                }}
            >
                Gem i logbogen
            </SecondaryButton>
        </Exercise>
    );
}
